module.exports = __webpack_public_path__ + "static/media/logo-go-munity-white.6ae60418.png";